import { shipmentManifest } from './shipment-manifest';

export const batchShipmentManifest = {
  ...shipmentManifest,
  id: 'batch-shipment-manifest',
};
